export const loadLink = ({ href, onloadFn = () => { }, onErrorFn = null, rel = 'stylesheet', throwOnError = true }) => {
  const linkEl = document.createElement('link')
  linkEl.href = href
  linkEl.rel = rel
  linkEl.onload = (...args) => onloadFn(...args)

  if (onErrorFn || throwOnError) {
    linkEl.onerror = onErrorFn ? e => onErrorFn(e) : e => {
      const err = new Error('Link failed to load')
      err.originalError = e
      throw err
    }
  }

  document.head.appendChild(linkEl)
}
